/**
 * Created by andrey on 18.12.2020.
 */

const EditorMap2dView = cleverapps.UI.ScrollView.extend({
    ctor: function (options) {
        const editor = Editor.currentEditor;
        const map = new EditorMap2dInnerView(editor.map);

        this._super(map, {
            childrenVisibility: false,
            scrollBarEnabled: false,
            outOfBoundaryScale: 0.25,
            inertialScrollFactor: 0.2,
            zoom: {
                minZoom: 0.05
            }
        });

        editor.map.scroller.onDiscoverScrollView = function () {
            return this;
        }.bind(this);

        this.setContentSize2(options.width, options.height);
        this.setAlignment({ align: "right" }, { align: "center" });
        this.baseWidth = this.width;

        this.scrollTo(cleverapps.UI.ScrollView.SCROLLS.CENTER);

        cleverapps.inputDispatcher.on("keypressed", (keyCode) => {
            if (keyCode === InputDispatcher.KEY.ctrl || keyCode === InputDispatcher.KEY.b) {
                this.touchScrollDisabled = true;
            }
        }, this);

        cleverapps.inputDispatcher.on("keyreleased", (keyCode) => {
            if (keyCode === InputDispatcher.KEY.ctrl || InputDispatcher.KEY.b) {
                this.touchScrollDisabled = false;
            }
        }, this);

        map.isVisiblePoint = this.isVisiblePoint.bind(this);
    }
});